import { Controller } from 'stimulus';
import { copyToClipboard } from '../../public/common';

export default class extends Controller {
  static targets = ['copyLink'];

  toggleCopyState({target, done}) {
    const icon = target.children[0];
    const classList = ['icomoon-copy', 'icomoon-checkmark', 'text-success', 'copy-button_success'];

    if (done) {
      icon.classList.replace(classList[0], classList[1]);
      icon.classList.add(classList[2]);
      target.classList.add(classList[3]);
    } else {
      icon.classList.replace(classList[1], classList[0]);
      icon.classList.remove(classList[2]);
      target.classList.remove(classList[3]);
    }

    target.disabled = done;
  }

  copyToClipboard(e) {
    e.stopPropagation();
    e.preventDefault();

    const target = e.currentTarget;
    const {value} = target.dataset;

    if (!target.classList.contains('copy-button_success')) {
      try {
        this.copyLinkTargets.forEach(target => {
          this.toggleCopyState({target, done: false});
        });
      } catch (e) {
      }

      copyToClipboard(value);

      this.toggleCopyState({target, done: true});

      setTimeout(() => {
        this.toggleCopyState({target, done: false});
      }, 5000);
    }
  }
}
